import { EpimsBaseEntityDto } from './epim-base.dto';
export class DamageStatusDto extends EpimsBaseEntityDto {
  DamageStatusName: string;
  SubscriptionUserId: string;
  Version: number;
}
